<template>
    <li class="privacy-mode-toggle-menu">
        <a href="#"
           class="dropdown-warning"
           :title="title"
           :class="{ 'privacy-mode-on': isEnabled }"
           @click.prevent="toggle">
            <i :class="iconClass"></i>
            <span class="hidden-xs" style="margin-left: 6px;">{{ label }}</span>
        </a>
    </li>
</template>

<script>
export default {
    name: 'TopbarPrivacyModeToggle',
    props: {
        enabled: {
            type: Boolean,
            required: true
        },
        updateRoute: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: 'Privacy'
        }
    },
    data() {
        return {
            isEnabled: this.enabled,
            isLoading: false
        }
    },
    computed: {
        iconClass() {
            return this.isEnabled ? 'fa fa-eye-slash' : 'fa fa-eye';
        },
        title() {
            return this.isEnabled
                ? _t('application.privacy_mode_disable')
                : _t('application.privacy_mode_enable');
        }
    },
    watch: {
        enabled(value) {
            this.isEnabled = value;
        }
    },
    methods: {
        toggle() {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;

            const nextEnabled = !this.isEnabled;
            const formData = new FormData();
            formData.append('enabled', nextEnabled ? '1' : '0');

            axios.post(this.updateRoute, formData)
                .then(response => {
                    if (response.data.success) {
                        this.isEnabled = !!response.data.enabled;
                        this.showSuccessToast(this.isEnabled);

                        setTimeout(() => {
                            window.location.reload();
                        }, 300);
                    }
                })
                .catch(error => {
                    console.error('Error toggling privacy mode:', error);
                    this.showErrorToast();
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        showSuccessToast(enabled) {
            if (typeof Swal === 'undefined') {
                return;
            }

            Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000,
                icon: 'success',
                title: enabled
                    ? _t('application.privacy_mode_enabled_toast')
                    : _t('application.privacy_mode_disabled_toast')
            });
        },
        showErrorToast() {
            if (typeof Swal === 'undefined') {
                return;
            }

            Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                icon: 'error',
                title: _t('application.privacy_mode_error_toast')
            });
        }
    }
}
</script>

<style scoped>
.privacy-mode-toggle-menu a.privacy-mode-on {
    color: #f39c12 !important;
}
</style>
